import React, { useState, useEffect } from 'react';
import AddDoctor from './AddDoctor';
import './Doctors.css';

const API_BASE = 'https://parachadental.com/dental-api';

const Doctors = () => {
    const [doctors, setDoctors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingDoctor, setEditingDoctor] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState('all');

    const fetchDoctors = async () => {
        try {
            const response = await fetch(`${API_BASE}/fetch-doctors.php`);
            const data = await response.json();
            if (data.success) setDoctors(data.doctors);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchDoctors(); }, []);

    const handleSave = () => { fetchDoctors(); };

    const handleEdit = (doctor) => {
        setEditingDoctor(doctor);
        setIsModalOpen(true);
    };

    const handleDelete = async (id) => {
        if (window.confirm('Delete this doctor?')) {
            const response = await fetch(`${API_BASE}/delete-doctor.php`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id })
            });
            const data = await response.json();
            if (data.success) fetchDoctors();
        }
    };

    const filteredDoctors = doctors.filter(doctor => {
        const matchesStatus = filterStatus === 'all' || doctor.status === filterStatus;
        const matchesSearch = doctor.doctor_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                              doctor.specialization.toLowerCase().includes(searchTerm.toLowerCase()) ||
                              doctor.email.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesStatus && matchesSearch;
    });

    const getStatusBadge = (status) => (
        <span className={`status-badge ${status}`}>{status}</span>
    );

    if (loading) return <div className="loading">Loading doctors...</div>;

    return (
        <div className="doctors-container">
            <div className="container">
                <div className="doctors-header">
                    <div><h1>Doctors</h1><p>Manage all doctors in your clinic</p></div>
                    <button className="btn-create" onClick={() => { setEditingDoctor(null); setIsModalOpen(true); }}>+ Add New Doctor</button>
                </div>

                <div className="filters-bar">
                    <div className="search-box">
                        <input type="text" placeholder="Search by name, specialization or email..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                    </div>
                    <div className="status-filters">
                        <button className={`filter-btn ${filterStatus === 'all' ? 'active' : ''}`} onClick={() => setFilterStatus('all')}>All</button>
                        <button className={`filter-btn ${filterStatus === 'active' ? 'active' : ''}`} onClick={() => setFilterStatus('active')}>Active</button>
                        <button className={`filter-btn ${filterStatus === 'inactive' ? 'active' : ''}`} onClick={() => setFilterStatus('inactive')}>Inactive</button>
                    </div>
                </div>

                <div className="doctors-card-container">
                    {filteredDoctors.length === 0 ? (
                        <div className="no-data"><p>No doctors found</p><button className="btn-create" onClick={() => { setEditingDoctor(null); setIsModalOpen(true); }}>Add your first doctor</button></div>
                    ) : (
                        <div className="doctors-grid">
                            {filteredDoctors.map((doctor) => (
                                <div className="doctor-card" key={doctor.id}>
                                    <div className="doctor-card-header">
                                        <h3>{doctor.doctor_name}</h3>
                                        {getStatusBadge(doctor.status)}
                                    </div>
                                    <div className="doctor-card-body">
                                        <p><strong>Specialization:</strong> {doctor.specialization}</p>
                                        <p><strong>Email:</strong> {doctor.email}</p>
                                        <p><strong>Phone:</strong> {doctor.phone}</p>
                                        <p><strong>Experience:</strong> {doctor.experience_years} years</p>
                                        <p><strong>Qualification:</strong> {doctor.qualification || 'N/A'}</p>
                                        <p><strong>Bio:</strong> {doctor.bio?.substring(0, 100)}...</p>
                                    </div>
                                    <div className="doctor-card-footer">
                                        <button className="action-btn edit" onClick={() => handleEdit(doctor)}>Edit</button>
                                        <button className="action-btn delete" onClick={() => handleDelete(doctor.id)}>Delete</button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="stats-summary">
                    <div className="stat-item"><span className="stat-label">Total Doctors:</span><span className="stat-value">{doctors.length}</span></div>
                    <div className="stat-item"><span className="stat-label">Active:</span><span className="stat-value active">{doctors.filter(d => d.status === 'active').length}</span></div>
                    <div className="stat-item"><span className="stat-label">Inactive:</span><span className="stat-value inactive">{doctors.filter(d => d.status === 'inactive').length}</span></div>
                </div>
            </div>

            <AddDoctor isOpen={isModalOpen} onClose={() => { setIsModalOpen(false); setEditingDoctor(null); }} onSave={handleSave} doctorToEdit={editingDoctor} />
        </div>
    );
};

export default Doctors;